var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "PopUpContainer",
    {
      on: {
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "absolute z-20 md:right-0 mt-2 w-64 sm:w-72 shadow-lg" },
        [
          _vm.$apollo.loading
            ? _c("LoadingOverlay", {
                staticClass: "overlay bg-white rounded-md",
                attrs: {
                  loading: _vm.$apollo.loading,
                  hasData: false,
                  spinnerCentered: "",
                },
              })
            : _c(
                "div",
                {
                  staticClass:
                    "rounded-md bg-white shadow-xs h-full overflow-hidden",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "px-4 py-2 text-center text-sm",
                      class: _vm.noNotificationsContainerStyles,
                    },
                    [_vm._v(" No new notifications ")]
                  ),
                ]
              ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }